export var getAnnouncementHeadingId = function getAnnouncementHeadingId(id) {
  return "announcement-heading-id-".concat(id);
};